<template>
  <NetworkStatus v-if="isOffline" />
  <div v-else> 
  <div class="p-5 container-fluid" style="margin-bottom: 120px">
    <div class="description">
      <div class="student-form-title">
        <h4>{{ $t("updatepayment.group") }} {{ configdetails.name }}</h4>
      </div>
      <div class="student-form">
        <form class="form col-xs-7 col-md-6 col-lg-7">
          <!-- Nom du groupe -->
          <div class="mb-4">
            <p class="small">{{ $t("newpayment.group_name") }}</p>
            <input
              type="text"
              class="form-control"
              style="height: 50px"
              v-model="configdetails.name"
              :placeholder="$t('newpayment.group_name_placeholder')"
            />
          </div>

          <!--
            Niveaux du groupe, même sélection que l'écran de création : un
            groupe couvre plusieurs niveaux entiers (grade_code_list).
          -->
          <div class="mb-4">
            <div class="d-flex align-items-center justify-content-between">
              <p class="small mb-0">{{ $t("newpayment.select_grades") }}</p>
              <span class="selected-count" :class="{ 'is-empty': !selectedGrades.length }">
                {{ $t("newpayment.selected_count", { count: selectedGrades.length }) }}
              </span>
            </div>
            <p class="text-xs mb-2" style="opacity: 0.55">
              {{ $t("newpayment.select_grades_hint") }}
            </p>

            <div class="grade-picker" v-if="GRADE_CODE.length">
              <label
                class="grade-chip"
                :class="{ active: isGradeSelected(grade) }"
                v-for="grade in GRADE_CODE"
                :key="grade.id || grade.code"
              >
                <input
                  type="checkbox"
                  :checked="isGradeSelected(grade)"
                  @change="toggleGrade(grade)"
                />
                <span class="grade-chip-name">{{ grade.name }}</span>
                <span class="grade-chip-count">{{ classCountLabel(grade) }}</span>
              </label>
            </div>
          </div>

          <!-- Spécialité : facultative, vide = toutes spécialités -->
          <div class="mb-4" v-if="SPECIALITY_CODE.length">
            <p class="small">{{ $t("newpayment.speciality_optional") }}</p>
            <select
              class="form-control form-select"
              style="height: 50px"
              v-model="configdetails.speciality_code"
            >
              <option value="">{{ $t("newpayment.all_specialities") }}</option>
              <option
                v-for="item in SPECIALITY_CODE"
                :key="item.code || item.short_name"
                :value="item.short_name"
              >
                {{ item.short_name }} - {{ item.title }}
              </option>
            </select>
          </div>

          <div class="container" style="margin-bottom: 100px">
            <div class="installment">
              <div class="row">
                <form class="form col-md-7 mt-6" v-for="(installment, index) in installments" :key="index">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label>
                          {{ $t("account.installment_number") }}
                          <em style="color: #f60000">*</em>
                        </label>
                        <argon-input :placeholder="$t('account.installment_number')" is-required
                          v-model="installment.number"></argon-input>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label>
                          {{ $t("account.installment_amount") }}
                          <em style="color: #f60000">*</em>
                        </label>
                        <argon-input :placeholder="$t('account.installment_amount')" is-required
                          v-model="installment.amount"></argon-input>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label>
                          {{ $t("account.due_date") }}
                          <em style="color: #f60000">*</em>
                        </label>
                        <argon-input is-required type="date" v-model="installment.due_date"></argon-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div>
                        <label>
                          {{ $t("account.installment_label") }}
                          <em style="color: #f60000">*</em>
                        </label>
                        <textarea class="form-control row-3" v-model="installment.label" rows="3"
                          :placeholder="$t('account.installment_label')"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="btn border border-danger detail" title="Supprimer l'installment" v-if="index !== 0"
                    @click="removeInstallment(index)">
                    <i class="i fa fa-times"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="row p-1 mt-5 g-3">
             
            <div class="col-lg-6">
              <argon-button data-bs-toggle="modal" data-bs-target="#staticBackdrop4" size="lg" color="success"
                full-width>
                <span>{{ $t("button.save") }}</span>
              </argon-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!--========================= modal modify =================================== -->

  <div class="modal fade" id="staticBackdrop4" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel4" aria-hidden="true">
    <div class="modal-dialog">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: 1px solid rgba(255, 255, 255, 0.4)">
            <h5 class="modal-title" id="staticBackdropLabel4"></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center pt-4 pb-4">
            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
            <h6> {{ $t("updatepayment.modal_title") }}</h6>
            <table class="table " style="
             width: 60%;
             margin:50px auto;
            " >
              <thead>
                <tr>
                  <th style="border: 1px solid rgba(255, 255, 255, 0.4)" scope="col">{{ $t("payment.group") }}</th>
                  <th style="border: 1px solid rgba(255, 255, 255, 0.4)" scope="col">{{ $t("payment.grades") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>

                  <td style="border: 1px solid rgba(255, 255, 255, 0.4)">{{ configdetails.name }}</td>
                  <td style="border: 1px solid rgba(255, 255, 255, 0.4)">{{ selectedGradeNames }}</td>

                </tr>
                


              </tbody>
            </table>


          </div>
          <div class="modal-footer" style="border-top: 1px solid rgba(255, 255, 255, 0.4)">
            <argon-button type="button"   data-bs-dismiss="modal" class="bg-transparent"
              style="width: 150px; height: 50px; padding-top: 15px; border:1px solid rgba(255, 255, 255, 0.4)">
              {{ $t("button.cancel") }}
            </argon-button>

            <argon-button :loading="loading" :active="buttonActive" class="btn mt-1 btn-danger"  type="button"
               style="width: 150px; height: 50px; padding-top: 15px" @click="updateConfig">
              {{ $t("button.confirm") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton";
import NetworkStatus from "@/views/components/NetworkStatus.vue";
import {
  updateConfig,
  getGrades,
  getSpeciality,
  getconfig,
} from "@/utils/services";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "ConfigForm",
  components: { ArgonButton, NetworkStatus  },
  data() {
    return {
      SPECIALITY_CODE: [],
      /* Codes des niveaux cochés. */
      selectedGrades: [],
      loading: false,
      GRADE_CODE: [],
      configData: null,
      installments: [],
      buttonActive: false,
      isOffline: false,  
      apiError: false, 
      configdetails: {
        name: "",
        speciality_code: "",
      },
    };
  },
  async mounted() {
    await this.updateOnlineStatus();

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    /*
     * Chargement séquencé, et non éclaté sur created / beforeMount / mounted
     * comme auparavant : les niveaux doivent être chargés AVANT le groupe,
     * sinon le compteur de classes se calcule sur une liste encore vide et
     * n'est jamais recalculé.
     */
    await this.getData();
    await this.loadConfigDetails();
  },

  beforeUnmount() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);

  },
  computed: {
    /** Noms des niveaux cochés, pour le récapitulatif de confirmation. */
    selectedGradeNames() {
      const names = this.GRADE_CODE
        .filter((grade) => this.selectedGrades.includes(this.gradeCode(grade)))
        .map((grade) => grade.name);
      return names.length ? names.join(", ") : "—";
    },
  },
  methods: {

    async updateOnlineStatus() {
    // Vérifier si le navigateur est en ligne
    if (navigator.onLine) {
      try {
        // Vérifier si les API sont accessibles
        await this.checkConnection(this.$route.params.id);
        this.isOffline = false; // Tout fonctionne, on est en ligne
      } catch (error) {
        console.error("Error checking connection:", error);
        this.isOffline = true; // Les API ne répondent pas, on est hors ligne
      }
    } else {
      // Pas de connexion internet détectée
      this.isOffline = true;
    }
  },

  async checkConnection(configId) {
    try {
      // Essayer les deux appels API
      await Promise.all([
      await getconfig(configId)
         
      ]);
      this.apiError = false; // Les API répondent correctement
    } catch (error) {
      console.error("API Error:", error);
      this.apiError = true; // Les API ne répondent pas
    }
  },

    gotogroup() {
      this.$router.push({
        path: "/payment-config",
        query: { forceReload: true },
      });
    },

    /** Code d'un niveau, tel qu'attendu par l'API. */
    gradeCode(grade) {
      return grade.code || grade.name;
    },
    isGradeSelected(grade) {
      return this.selectedGrades.includes(this.gradeCode(grade));
    },
    toggleGrade(grade) {
      const code = this.gradeCode(grade);
      const index = this.selectedGrades.indexOf(code);
      if (index === -1) this.selectedGrades.push(code);
      else this.selectedGrades.splice(index, 1);
    },
    /** Nombre de classes du niveau, à titre indicatif. */
    classCountLabel(grade) {
      const count = (grade.classrooms || []).length;
      return this.$t("newpayment.class_count", { count });
    },

    async loadConfigDetails() {
      try {
        const configId = this.$route.params.id;
        const response = await getconfig(configId);
        // getconfig renvoie l'objet directement, mais d'autres services du
        // fichier renvoient { status, data } : on accepte les deux formes
        // plutôt que de dépendre d'une convention non garantie.
        const configdetails = (response && response.data) || response || {};

        this.configdetails = {
          id: configdetails.id,
          name: configdetails.name || "",
          speciality_code: configdetails.speciality_code || "",
        };
        // Niveaux déjà rattachés au groupe : ils apparaissent cochés.
        this.selectedGrades = [...(configdetails.grade_code_list || [])];
      } catch (error) {
        console.error(
          "Erreur lors du chargement des détails de la config:",
          error
        );
      }
    },

    async getData() {
      try {
        let grades = await getGrades();
        this.GRADE_CODE = (grades && grades.data) || [];
        let specialities = await getSpeciality();
        this.SPECIALITY_CODE = (specialities && specialities.data) || [];
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async updateConfig() {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true; // Activer le chargement
        this.button = "disabled";
        this.buttonActive = true;

        const configId = this.configdetails.id;
        const data = {
          name: this.configdetails.name,
          grade_code_list: [...this.selectedGrades],
          // Vide = toutes les spécialités des niveaux cochés.
          speciality_code: this.configdetails.speciality_code || "",
        };

        let res = await updateConfig(configId, data);



        if (!navigator.onLine) {
          this.releaseButton();
          toast.error(this.$t("message.notinternet"), { autoClose: 3000 });
        } else if (res.status === 200) {
          toast.success(this.$t("updatepayment.message"), { autoClose: 3000 });

          // Fermeture propre via l'API Bootstrap : retirer à la main la
          // classe `modal-open` et les fonds ne suffisait pas — le modal
          // lui-même gardait `.show` et restait affiché après la
          // redirection.
          this.closeModal();

          this.$router.push({
            path: "/payment-config",
            query: { forceReload: true },
          });
        } else {
          this.releaseButton();
        }
      } catch (error) {
        this.releaseButton();
        console.error(error);

        if (error.response && error.response.status === 404) {
          toast.error("User not found. Please check the provided information", {
            autoClose: 3000,
          });
        } else {
          toast.error("An error occurred during configuration update", {
            autoClose: 3000,
          });
        }
      }
    },
    /**
     * Réactive le bouton.
     *
     * Appelé uniquement en cas d'échec : en cas de succès, le spinner doit
     * rester visible jusqu'à la redirection, sinon le bouton redevient actif
     * alors que la navigation est déjà lancée.
     */
    releaseButton() {
      this.loading = false;
      this.button = "";
      this.buttonActive = false;
    },
    /**
     * Ferme le modal de confirmation.
     *
     * On passe par l'instance Bootstrap quand elle existe, avec repli manuel
     * (classes + fonds) pour les cas où le modal n'a pas été instancié par
     * `data-bs-toggle`.
     */
    closeModal() {
      const element = document.getElementById("staticBackdrop4");
      const Modal = window.bootstrap && window.bootstrap.Modal;
      if (element && Modal) {
        const instance = Modal.getInstance(element) || new Modal(element);
        instance.hide();
      } else if (element) {
        element.classList.remove("show");
        element.style.display = "none";
        element.setAttribute("aria-hidden", "true");
      }
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("padding-right");
      document
        .querySelectorAll(".modal-backdrop")
        .forEach((backdrop) => backdrop.remove());
    },
  },

  created() {
    this.confiId = this.$route.params.id;
    const configDataParam = this.$route.query.configData;
    if (configDataParam) {
      try {
        this.configData = JSON.parse(configDataParam);
      } catch (error) {
        console.error("Error parsing configData:", error);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.student-form {
  display: flex;
  justify-content: center;
  margin-top: 5vh;
}

.student-form-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info {
  color: #dc3545;
  font-size: 14px;
  margin-left: 5px;
}

.required {
  border-color: #f60000 !important;
}

/* --- Sélecteur de niveaux ----------------------------------------------- */

.grade-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 14px;
  max-height: 300px;
  overflow-y: auto;
}

/* La case à cocher est masquée : c'est toute la pastille qui sert de cible,
   plus confortable à viser qu'un petit carré. */
.grade-chip {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  padding: 9px 16px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 0;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.grade-chip input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.grade-chip:hover {
  border-color: rgba(46, 206, 191, 0.5);
}

.grade-chip.active {
  border-color: #2ecebf;
  background: rgba(46, 206, 191, 0.12);
  color: #2ecebf;
}

.grade-chip-name {
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.2;
}

.grade-chip-count {
  font-size: 10.5px;
  opacity: 0.55;
  line-height: 1.2;
}

.selected-count {
  font-size: 11px;
  color: #2ecebf;
  font-variant-numeric: tabular-nums;
}

.selected-count.is-empty {
  color: inherit;
  opacity: 0.45;
}

</style>
